<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h3 class="box-title" style="margin-top: 0px">
          RESULTADO DA SIMULAÇÃO
        </h3>
      </div>
    </div>
    <div class="content">
      <table class="table table-striped">
        <tbody>
          <tr>
            <th scope="row">Valor Entrada</th>
            <td class="text-right">
              {{ 0 | reais }}
            </td>
          </tr>
          <tr>
            <th scope="row">Valor Líquido Liberado</th>
            <td class="text-right">
              {{ this.simulationData.resultadoSimulacao.ValorSolicitado | reais }}
            </td>
          </tr>
          <tr>
            <th scope="row">Valor IOF</th>
            <td class="text-right">
              {{ this.simulationData.resultadoSimulacao.VlrIOF | reais }}
            </td>
          </tr>
          <tr>
            <th scope="row">Parcelas</th>
            <td class="text-right">
              {{ this.simulationData.resultadoSimulacao.Prazo }}
              vezes de
              {{ this.simulationData.resultadoSimulacao.VlrParcela | reais }}
            </td>
          </tr>
          <tr>
            <th scope="row">Percentual Juros Mensais</th>
            <td class="text-right">
              {{
                this.simulationData.resultadoSimulacao.PercJurosMensal.toFixed(2).replace(
                  ".",
                  ","
                )
              }}%
            </td>
          </tr>
          <tr>
            <th scope="row">Percentual Juros Anuais</th>
            <td class="text-right">
              {{
                this.simulationData.resultadoSimulacao.PercJurosAnual.toFixed(2).replace(
                  ".",
                  ","
                )
              }}%
            </td>
          </tr>
          <tr>
            <th scope="row">Percentual CET Mensal</th>
            <td class="text-right">
              {{
                this.simulationData.resultadoSimulacao.PercCETMensal.toFixed(2).replace(
                  ".",
                  ","
                )
              }}%
            </td>
          </tr>
          <tr>
            <th scope="row">Percentual CET Anual</th>
            <td class="text-right">
              {{
                this.simulationData.resultadoSimulacao.PercCETAnual.toFixed(2).replace(
                  ".",
                  ","
                )
              }}%
            </td>
          </tr>
          <tr>
            <th scope="row">Valor Total Financiado</th>
            <td class="text-right">
              {{ this.simulationData.resultadoSimulacao.VlrTotalCredito | reais }}
            </td>
          </tr>
          <tr>
            <th scope="row">Valor Total Pago Final</th>
            <td class="text-right">
              {{ this.simulationData.resultadoSimulacao.VlrTotalDivida | reais }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped>
@media (min-width: 992px) {
  .btn-simular {
    margin-top: 2.2em;
  }
}
</style>

<script>
import FormHelper from "@/components/partials/FormHelper.vue";

export default {
  name: "SimulationSolAgoraStep2",
  props: {
    precoEUP: { type: Number, default: 0 },
    simulationData: { type: Object, default: null },
  },
  components: {
    FormHelper,
  },
  created() {

  },
  methods: {

    nextStep: async function () {
      this.loading = true;

      try {
        this.form.attemptSubmit = true;

        if (this.formErrors !== 0) return;

        this.$emit("next");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>